import {showMessage} from "./modals";

const checkGeoLocation = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successCheckedGeoLocation, errorGeoLocation);
    } else {
        window.canLikeItem = false;
        console.warn(window.jsLocalizations['error_geolocation'])
    }
};

const successCheckedGeoLocation = (position) => {
    let sendData = {
        '_token': $('meta[name="csrf-token"]').attr('content'),
        'longitude': position.coords.longitude,
        'latitude': position.coords.latitude,
    };
    return $.post($('.js-check-geolocation').val(), sendData, (ans) => {
        window.canLikeItem = ans && ans.allowed;
    });
};

const errorGeoLocation = (reason) => {
    showMessage(window.jsLocalizations[reason.message] || reason.message, false, false, 'error');
};

export { checkGeoLocation, successCheckedGeoLocation, errorGeoLocation }
